import { lazy } from 'react';
import { ROLE_LTN_ADMIN } from 'Constants';

export default {
  ui: 'menuLeft',
  auth: { role: ROLE_LTN_ADMIN },
  path: 'admin',
  title: 'Admin',
  urlParams: '/:page?',
  component: lazy(() => import('./index')),
  children: [
    {
      path: '/tags',
      urlParams: '/:id?/:action?',
      component: lazy(() => import('./views/tags-view')),
      title: 'Tags',
      pageTitle: 'Tags',
    },
    {
      path: '/hardware_models',
      urlParams: '/:id?/:action?',
      component: lazy(() => import('./views/hardware-models-view')),
      title: 'Hardware Models',
      pageTitle: 'Hardware Models',
    },
    {
      path: '/mobile_ingest_clients',
      urlParams: '/:id?/:action?',
      component: lazy(() => import('./views/mobile-ingest-clients-view')),
      title: 'Mobile Ingest Clients',
      pageTitle: 'Mobile Ingest Clients',
    },
    {
      path: '/decoder_configuration_profiles',
      urlParams: '/:id?/:action?',
      component: lazy(() => import('./views/decoder-configuration-profiles-view')),
      title: 'Decoder Configuration Profiles',
      pageTitle: 'Decoder Configuration Profiles',
    },
    {
      path: '/encoder_configuration_profiles',
      urlParams: '/:id?/:action?',
      component: lazy(() => import('./views/encoder-configuration-profiles-view')),
      title: 'Encoder Configuration Profiles',
      pageTitle: 'Encoder Configuration Profiles',
    },
    {
      path: '/thumbnailer_configuration_profiles',
      urlParams: '/:id?/:action?',
      component: lazy(() => import('./views/thumbnailer-configuration-profiles-view')),
      title: 'Thumbnailer Configuration Profiles',
      pageTitle: 'Thumbnailer Configuration Profiles',
    },
    {
      path: '/channel_tags',
      urlParams: '/:view?/:id?',
      component: lazy(() => import('./views/channel-tags-view')),
      title: 'Channel Tags',
      pageTitle: 'Channel Tags',
    },
    {
      path: '/managers',
      component: lazy(() => import('./views/managers-view')),
      title: 'Managers',
      pageTitle: 'Managers',
    },
    {
      path: '/controllers',
      component: lazy(() => import('./views/controllers-view')),
      title: 'Controllers',
      pageTitle: 'Controllers',
    },
    {
      path: '/communicators',
      component: lazy(() => import('./views/communicators-view')),
      title: 'Communicators',
      pageTitle: 'Communicators',
    },
  ],
};
